module.exports = __webpack_public_path__ + "img/hookedondevelopment_notcompleted.2a32a540.svg";